import {useEffect} from "react";
import { useNavigate } from 'react-router-dom';




export default function Splash(){
    let navigate = useNavigate();

    useEffect(() => {
        setTimeout(()=>{
            console.log("hello");
            navigate("/welcome");
        },2000);
    }, [])


    return (
        <div style={{fontFamily:'Montserrat'}} className='h-screen w-full flex bg-gradient-to-t from-blue-900 to-blue-400 items-center justify-center'>

            <div className="flex flex-col justify-center items-center">

                <div className="w-3/4 md:w-2/4 backdrop-blur-sm rounded-md">
                    <img alt="logo" src="/logo.png"/>
                </div>

                <div className="text-white font-bold text-4xl">
                    Admin Panel
                </div>

            </div>
        </div>
    )

}